import { getCurrentProvider } from './manageSessionStorageData'
import { NavigationConfig } from '../../interfaces/NavigationConfig'
import { isAccessible } from './rolesAndPermissions'

export const hasAccess = (nav: NavigationConfig): boolean =>
    nav.type === getCurrentProvider() && (!nav.permission || (nav.permission && isAccessible(nav.permission)))
